import React, {useState} from "react";
import { Box, Button } from "@mui/material";
import DynamicTableForJson from "../../../../../data/DynamicTable/dynamicTableForJson";
import { customerservice } from "../../../../../config";
import GuarantorForm from "./form";
import { useNavigate } from "react-router-dom";
import Joyride from "react-joyride"; // 🚀 Import Joyride



const base_url = customerservice.uri;

// Define tour steps for the Rights page
const rightsTourSteps = [
  {
    target: ".dynamic-table-header",
    content: "This is the Guarantor Management page, where you can manage customer's guarantor.",
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".dynamic-table-search",
    content: "Use the search bar to find specific guarantors by name or other criteria.",
    placement: "bottom",
  },
  {
    target: ".dynamic-table-add-button",
    content: "Click this button to add a new guarantor.",
    placement: "right",
  },
  {
    target: ".dynamic-table-guarantor360-button",
    content: "Click this button to view guarantor detail with any attached images.",
    placement: "right",
  },
  // {
  //   target: ".dynamic-table-grid",
  //   content: "This table displays all rights. You can view and manage them here.",
  //   placement: "top",
  // },
  {
    target: ".dynamic-table-actions",
    content: "Select actions like Edit or Guarantor 360  for each right from this dropdown.",
    placement: "left",
  },
];

const GuarantorsTable = () => {
    const [runTour, setRunTour] = useState(false); // ▶️ State to control Joyride

  const customerId= localStorage.getItem("CustomerId")
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const roleGroupId = parseInt(decodedToken.RoleGroupId)
  const companyId = parseInt(decodedToken.CompanyId);
  const navigate = useNavigate();
  const customerstatus= parseInt(localStorage.getItem("Status") || 0)
  // const showButton = customerstatus === 1 ||customerstatus === 0 || localStorage.getItem("Status") === null;
  const restrictedRoles = [3, 4];

  const baseShowButton =
    customerstatus === 1 ||
    customerstatus === 0 ||
    localStorage.getItem("Status") === null;

  const showButton =
    companyId === 29
      ? baseShowButton && !restrictedRoles.includes(roleGroupId)
      : baseShowButton;

const actions = {
  entity: "Guarantor",
  isSubright: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: showButton,
    permission: "EditPermission",
  },
    ViewGuarantor360: {
      key: "ViewAllCustomerDetails",
      button_name: "View Guarantor 360",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4, 5],
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: showButton,
      permission: "CreatePermission",
    },
     VerifyGuarantor: {
          key: "VerifyGuarantor",
          button_name: "Verify Guarantor",
          Show_Button: true,
          permission: "ActivatePermission",
          //roleGroupId: [1, 2, 3, 4],
        },
    dataObject: {
      ignoreFields: 
      [
        "Updateddate", 
        "DateCreated",
        "Verifiedby",
        "Verifieddate",
        "Photocontenttype",
        "Datecreated",
        "Createdby",
        "Updatedby",
        "VerifiedDate",
        "HouseName",
        "FloorNumber",
        "RoomNumber",
        "Photo",
        "PhotoContentType",
        "IdfrontPhoto",
        "IdbackPhoto",
        "Town",
        "PermanentResidence",
        "Dob",
        "RelationshipToLoanee",
        "MaritalStatus",
      ],
      objectName: "guarantorById",
      parameters:{customerId:parseInt(customerId)},
      inputObjectName:"guarantor"
    },

  };

  return (
    <Box m="20px">
         {/* 🧭 Joyride Component */}
            <Joyride
              steps={rightsTourSteps}
              run={runTour}
              continuous
              showSkipButton
              showProgress
              styles={{
                options: {
                  primaryColor: "#1976d2",
                  zIndex: 10000,
                },
              }}
            />
    
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
       <Button onClick={ () => navigate(-1)} variant="contained">
            Back to Customers
          </Button>
          <Button onClick={() => setRunTour(true)} variant="outlined" color="primary">
            Start Page Tour
        </Button>
      </Box>
      <>
      </>
      <DynamicTableForJson
        title="Guarantors"
        subtitle="Manage Guarantors"
        FormComponent={GuarantorForm}
        base_url={base_url}
        actions={actions}
        tourSteps={rightsTourSteps} // Pass tour steps as prop
      />
    </Box>
  );
};

export default GuarantorsTable;
